import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

import { Row, Col } from 'antd';

import { OverviewInfo, OverviewLocations } from '../index';

import userSelectors from '@redux/user/selectors';

import { Can } from 'context/Can';
import { ABILITY_ACTION, ABILITY_SUBJECT } from 'static/Permission';

import { useRefetchUserProfile } from 'pages/user-profile/components/hook/useFetchUserProfile';

import './UserProfileOverview.less';

const UserProfileOverview = (props) => {
  const { userProfile, editable, loginUserInfo } = props;

  const { fetch: fetchUserProfile } = useRefetchUserProfile();

  const userProfileLocations = useSelector(
    userSelectors.makeSelectUserProfileLocations()
  );

  const primaryAddress = userProfile?.primaryAddress;
  const [centerData, setCenterData] = useState(primaryAddress);
  const memberId = userProfile?.memberId || loginUserInfo?.member?.id;

  useEffect(() => {
    setCenterData(primaryAddress);
  }, [primaryAddress]);

  const userLocation = userProfileLocations?.data?.gridData;

  const handleGetUserProfile = () => {
    fetchUserProfile();
  };

  return (
    <Row className='user-profile-overview'>
      <Col span={24} style={{ paddingRight: 8 }}>
        <OverviewInfo
          overviewInfo={userProfile}
          officeList={userLocation}
          centerData={centerData}
          handleGetUserProfile={handleGetUserProfile}
          editable={editable}
          memberId={memberId}
        />
        <OverviewLocations
          changeRow={(item) => setCenterData(item)}
          editable={editable}
          userProfile={userProfile}
        />
      </Col>
    </Row>
  );
};

export default UserProfileOverview;
